<template>
  <div class="retail-book retail-order-confirm mt40">
    <!-- 填写订单信息 -->
    <div class="book-wrap">
      <div class="title">确认订单</div>
      <div v-for="item in retailOrderList" :key="item.id">
        <!-- 收货地址 -->
        <div v-if="item.isDelivery" class="delivery-info">
          <div class="til">收货地址</div>
          <div class="address-list">
            <div v-for="receiver in receiverList" :key="receiver.id" class="address-item" :class="receiver.selected ? 'active' : ''" @click="handleSelectReceiver(receiver, item)">
              <div class="name-phone">
                <span class="name">{{receiver.consignee}}</span>
                <span class="phone">{{receiver.phone}}</span>
              </div>
              <div class="city">{{receiver.areaName}}</div>
              <div class="address">{{receiver.address}}</div>
              <div v-if="receiver.selected" class="update-btn">
                <span @click.stop="handleUpdate(receiver)">修改</span>
              </div>
            </div>
            <div class="address-item">
              <div class="add-icon" @click="showpop = true"><img src="../../assets/images/add-address-icon.png" alt=""></div>
              <div class="add-text" @click="showpop = true">添加新地址</div>
            </div>
          </div>
        </div>
        <!-- 取货信息 -->
        <div v-else class="contact-info">
          <div class="part">
            <div class="til">取货信息</div>
            <div class="inner">
              <div class="line">
                <span class="label">取货地址:</span>
                <span class="cont">{{item.address || '暂无'}}</span>
              </div>
              <div class="line">
                <span class="label">联系电话:</span>
                <span class="cont">{{item.phone || '暂无'}}</span>
              </div>
            </div>
          </div>
          <div class="part">
            <div class="til">取货人信息</div>
            <div class="inner">
              <!-- <div class="line">
                <span class="label">预计取货时间:</span>
                <el-date-picker placeholder="请选择取货时间"></el-date-picker>
              </div> -->
              <div class="line">
                <span class="label">预留电话:</span>
                <el-input v-model="item.contactMobile" placeholder="请输入取货人电话"></el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="order-info">
          <div class="title">订单信息</div>
          <div class="row row-header">
            <div class="row-item wid">
              <div class="goods-name">商品</div>
            </div>
            <div class="row-item">规格</div>
            <div class="row-item">单价</div>
            <div class="row-item">数量</div>
            <div class="row-item">优惠金额</div>
            <div class="row-item">小计</div>
          </div>
          <!-- 商品信息 -->
          <div class="store-list">
            <div class="store-item">
              <div class="store-name">{{item.industryName}}</div>
              <div class="goods-list">
                <div v-for="goods in item.goodsList" :key="goods.id" class="row">
                  <div class="row-item wid">
                    <div class="left">
                      <img :src="goods.goodsTargetThumbnail" alt="">
                    </div>
                    <div class="right">
                      {{goods.goodsTargetName || goods.name}}
                    </div>
                  </div>
                  <div class="row-item">
                    <!-- <span class="label">颜色:</span> -->
                    <span class="val">{{goods.attributes}}</span>
                  </div>
                  <div class="row-item">￥{{goods.goodsPrice}}</div>
                  <div class="row-item">{{goods.quantity}}</div>
                  <div class="row-item">{{goods.couponDiscount == null ? '暂无' : '￥' + goods.couponDiscount}}</div>
                  <div v-if="goods.goodsPrice != null" class="row-item">￥{{(goods.quantity * goods.goodsPrice).toFixed(2)}}</div>
                </div>
                <div class="sum">
                  <div class="left">
                    <div class="delivery">
                      <!-- <span class="label">运送方式:</span> -->
                      <!-- <span class="cont">申通快递(包邮)</span> -->
                    </div>
                    <div class="total">店铺合计</div>
                  </div>
                  <div class="right">
                    <!-- <div class="fee">￥0</div> -->
                    <div class="amount">￥{{item.amountPayable}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- 合计信息 -->
      <div class="total-info">
        <div class="total-amount">
          <span>总金额:</span>
          <span class="amount">¥ <em>{{amountPayable}}</em></span>
        </div>
        <div v-if="retailOrderList.length > 0 && retailOrderList[0].isDelivery && retailOrderList[0].receiverInfo" class="contact-info">
          <span>寄送至:</span>
          <span class="cont">{{retailOrderList[0].receiverInfo.areaName}} {{retailOrderList[0].receiverInfo.address}}</span>
        </div>
        <div v-if="retailOrderList.length > 0 && retailOrderList[0].isDelivery && retailOrderList[0].receiverInfo" class="contact-info">
          <span class="ml40">收货人:</span>
          <span class="cont">{{retailOrderList[0].receiverInfo.consignee}} {{retailOrderList[0].receiverInfo.phone}}</span>
        </div>
      </div>

      <!-- 立即购买 -->
      <div class="buy-btn">
        <el-button class="red-btn" @click="handleSubmitOrder">立即购买</el-button>
      </div>
    </div>

    <!-- 新增/编辑地址弹窗 -->
    <div class="shadow" :class="showpop ? '' : 'hide'">
      <div class="container">
        <div class="close"><img src="../../assets/images/close.png" alt="" @click="showpop = false"></div>
        <div class="title">编辑/添加地址</div>
        <el-form :model="form" ref="form" label-width="100px">
          <el-form-item label="收货人:" prop="consignee" :rules="[{required: true, message: '请输入收货人姓名'}]">
            <el-input v-model="form.consignee" class="form-input" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone" :rules="[{required: true,validator:validatorTel, message: '请输入正确的手机号码'}]">
            <el-input v-model="form.phone" class="form-input" placeholder="请输入收货人手机号"></el-input>
          </el-form-item>
          <el-form-item label="所在地区:" prop="area" :rules="[{required: true, message: '请选择省-市-区-街道'}]">
            <el-cascader v-model="form.area" class="form-input" :options="areaOptions" :props="{ value: 'id', label: 'name' }" placeholder="选择省-市-区-街道"></el-cascader>
          </el-form-item>
          <el-form-item class="mb0" label="收货地址:" prop="address" :rules="[{required: true, message: '请输入详细地址'}]">
            <el-input v-model="form.address" class="form-input" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="" prop="isDefault">
            <el-checkbox v-model="form.isDefault">设为常用收货地址</el-checkbox>
          </el-form-item>
        </el-form>
        <div class="btns">
          <el-button @click="closeAddressMOdal">关闭</el-button>
          <el-button @click="handleSubmit">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadReceiverList, saveReceiverInfo, updateReceiverInfo, createOrder } from '@/api/retail/retailOrderConfirm'
import { singleCalAmount, calAmount } from '@/api/retail/cart'
import { config } from '@/constant/config'
import { validaCellPhone } from '@/utils/validate'
export default {
  data () {
    return {
      receiverList: [],
      showpop: false,
      from: null,
      form: {
        consignee: null,
        phone: null,
        area: [],
        address: null,
        isDefault: false
      },
      areaOptions: [],
      retailOrderList: [],
      amountPayable: 0,
      receiverInfo: {}
    }
  },
  computed: {
  },
  created () {
    this.from = this.$route.query.from
    this.areaOptions = this.$store.state.areaList || []
    this.loadReceiverList()
    const retailOrderList = JSON.parse(localStorage.getItem('retailOrderList'))
    this.retailOrderList = retailOrderList.map(item => {
      item.isDelivery = item.goodsList.some(goods => goods.isDelivery || goods.isSupportDelivery)
      return item
    })
  },
  methods: {
    closeAddressMOdal () {
      this.form = {}
      this.showpop = false
    },
    validatorTel (rule, value, callback) {
      if ((!(/^1[3456789]\d{9}$/.test(value)))) {
        callback(new Error('请输入正确手机号'))
      } else {
        callback()
      }
    },
    // 购物车计算
    muiltiCalAmoount () {
      const cartItemGroups = []
      this.retailOrderList.map(item => {
        cartItemGroups.push({
          storeId: item.industryId,
          cartItems: item.goodsList.map(item => item.id)
        })
      })
      this.param = {
        cartItemGroups,
        merchId: config.MERCHID
      }
      calAmount(this.param).then(res => {
        if (res.code === 0) {
          const cartOrderCreateVOS = res.data.cartOrderCreateVOS
          this.retailOrderList.forEach(item => {
            const obj = cartOrderCreateVOS.find(store => store.storeId === item.industryId)
            item.phone = obj.phone
            item.address = obj.address
            item.amountPayable = obj.amount
            item.freight = obj.freight
          })
          this.amountPayable = res.data.amountPayable
        } else {
          this.$$message.error(res.error)
        }
      })
    },
    // 计算
    singleCalAmount () {
      this.param = {
        goodsId: this.retailOrderList[0].goodsList[0].skuObj.id,
        quantity: this.retailOrderList[0].goodsList[0].quantity
      }
      singleCalAmount(this.param).then(res => {
        if (res.code === 0) {
          const cartOrderCreateVOS = res.data.cartOrderCreateVOS
          this.retailOrderList.forEach(item => {
            const obj = cartOrderCreateVOS.find(store => store.storeId === item.industryId)
            item.phone = obj.phone
            item.address = obj.address
            item.amountPayable = obj.amount
            item.freight = obj.freight
          })
          this.retailOrderList[0].amountPayable = res.data.amountPayable
          this.retailOrderList[0].freight = res.data.freight
          this.amountPayable = res.data.amountPayable
        } else {
          this.$message.error(res.error)
        }
      })
    },
    loadReceiverList () {
      loadReceiverList().then(res => {
        if (res.code === 0) {
          this.receiverList = res.data.map(item => {
            if (item.isDefault) {
              item.selected = true
              this.retailOrderList.forEach(order => {
                order.receiverInfo = item
              })
            } else {
              item.selected = false
            }
            return item
          })
          if (this.from === 'cart') {
            this.muiltiCalAmoount()
          } else {
            this.singleCalAmount()
          }
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 选择地址
    handleSelectReceiver (rItem, item) {
      this.receiverList.forEach(receiver => {
        if (rItem.id !== receiver.id) receiver.selected = false
      })
      rItem.selected = true
      item.receiverInfo = rItem
    },
    // 更新地址
    handleUpdate (item) {
      if (item.areaId) item.area = item.areaId.split(',')
      this.form = { ...item }
      this.showpop = true
    },
    // 保存地址
    handleSubmit () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const param = JSON.parse(JSON.stringify(this.form))
          param.areaId = param.area.join()
          const provice = this.areaOptions.find(area => area.id === param.area[0])
          const city = provice.children.find(city => city.id === param.area[1])
          const county = provice.children.find(county => county.id === param.area[2]) || {}
          param.areaName = provice.name + city.name + (county.name || '')
          delete param.area
          let res = {}
          if (this.form.id) {
            res = await updateReceiverInfo(param)
          } else {
            res = await saveReceiverInfo(param)
          }
          if (res.code === 0) {
            this.$message.success('新增成功')
            this.loadReceiverList()
            this.$refs.form.resetFields()
            this.showpop = false
          } else {
            this.$message.error(res.error)
          }
        }
      })
    },
    // 提交订单
    handleSubmitOrder () {
      this.param.merchId = config.MERCHID
      if (this.retailOrderList[0].isDelivery) {
        this.param.receiveId = this.retailOrderList[0].receiverInfo.id
      } else {
        if (!validaCellPhone(this.retailOrderList[0].contactMobile)) {
          this.$message({
            message: '请输入正确的取货人电话',
            type: 'error'
          })
          return
        }
        this.param.contactMobile = this.retailOrderList[0].contactMobile
      }
      createOrder(this.param, this.from).then(res => {
        if (res.code === 0) {
          this.$router.replace({
            path: 'pay',
            query: {
              orderNo: res.data,
              from: this.from
            }
          })
        } else {
          this.$message.error(res.error)
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.retail-order-confirm {
  .row.row-header .wid .goods-name {
    margin-left: 105px;
  }
}
.retail-book {
  .book-wrap {
    max-width: 1279px;
    padding: 40px;
    overflow-x: auto;
    width: 1279px;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    .title {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 36px;
      color: #9B232A;
    }
    .delivery-info {
      margin-top: 40px;
      .til {
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 29px;
        color: #1D263A;
      }
      .address-list {
        display: flex;
        display: -webkit-flex;
        margin-bottom: 40px;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
        -webkit-flex-direction: row;
        -webkit-align-content: stretch;
        align-content: stretch;
        .address-item {
          width: calc(25% - 24px);
          height: 100%;
          padding: 21px 20px;
          margin-bottom: 6px;
          margin-right: 24px;
          border: 1px solid #BEC9DF;
          border-radius: 8px;
          flex-shrink: 0;
          box-sizing: border-box;
          cursor: pointer;
          &.active {
            border-color: #9B232A;
          }
          &::last-child {
            margin-right: 0;
          }
          .name-phone {
            display: flex;
            margin-bottom: 16px;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 21px;
              color: #242B34;
            }
            .phone {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 19px;
              color: #242B34;
            }
          }
          .city {
            margin-bottom: 8px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #242B34;
          }
          .address {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #9FA1B0;
          }

          .add-icon {
            text-align: center;
            img {
              width: 47px;
              height: 47px;
              cursor: pointer;
            }
          }
          .add-text {
            margin-top: 16px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #9FA1B0;
            text-align: center;
            cursor: pointer;
          }
        }

        .update-btn {
          text-align: right;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9B232A;
            cursor: pointer;
          }
        }
      }
    }

    .contact-info {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      align-items: center;
      justify-content: space-between;
      .part {
        width: calc(50% - 25px);
        &:first-child {
          margin-right: 49px;
        }
        .inner {
          padding: 24px 24px 20px 24px;
          background: #F5F5F7;
          border-radius: 8px;
        }

        &:last-child {
          .inner {
            padding-bottom: 38px;
          }
        }

        .til {
          margin-bottom: 20px;
          padding-left: 3px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 29px;
          color: #1D263A;
        }

        .line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          .label {
            display: inline-block;
            width: 140px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 21px;
            color: #9FA1B0;
          }
          .cont {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 21px;
            color: #242B34;
          }
          .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 100%;
          }
        }
      }
    }

    .order-info {
      .title {
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 29px;
        color: #1D263A;
      }

    }

    .total-info {
        margin-top: 40px;
        padding: 16px 20px 24px;
        background: #F5F5F5;
        text-align: right;
        .total-amount {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #424855;
          .amount {
            margin-left: 12px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #FF0000;
            em {
              font-style: normal;
              font-size: 28px;
            }
          }
        }

        .contact-info {
          margin-top: 10px;
          margin-bottom: 0;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9FA1B0;
          justify-content: flex-end;
          .ml40 {
            margin-left: 40px;
          }
          .cont {
            margin-left: 12px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #242B34;
          }
        }
      }

      .buy-btn {
        margin-top: 16px;
        text-align: right;
      }
  }

  .shadow {
    .container {

      .title {
        margin-bottom: 44px;
      }

      /deep/.form-input {
        width: 368px;
        height: 36px;
        padding: 0;
        border: none;
        border-radius: 4px;
        .el-input__inner {
          border: 1px solid #95A3AF;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 36px;
          color: #242B34;
          &::-webkit-input-placeholder{
            color: #95A3AF;
          }
          &:-moz-placeholder{
            color: #95A3AF;
          }
          &::-moz-placeholder{
            color: #95A3AF;
          }
          &:-ms-input-placeholder{
            color: #95A3AF;
          }
        }
      }

      /deep/.el-form-item__label {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #242B34;
        text-align: center;
      }

      /deep/.el-checkbox__label {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #242B34;
      }

      /deep/.el-checkbox__inner {
        width: 16px;
        height: 16px;
        &::after {
          left: 5px;
        }
      }

      .btns {
        margin-top: 50px;
      }
    }
  }
}
</style>
